import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {

  AUTHORIZATION = 'Authorization';
  baseUrl = environment.baseUrl

  constructor(private authService: AuthService, private http: HttpClient, private router: Router) { }

  bearerToken = '';

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      // let token = 'a22c1104b79a4e7e6082568b3c004e7a50fbb803b0b7097386648ae762058e89';
    let token = localStorage.getItem('jwt_token') || '';

    if (!token) {
      token = localStorage.getItem('refreshToken') || '';
    }

    const authReq = request.clone({
      setHeaders: { Authorization: token }
    });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !request.url.includes('/v1/auth/refresh')) {
          localStorage.removeItem('userToken')
          const loginToken = localStorage.getItem('refreshToken') || '';
          // If no loginToken, redirect to login page
          if (!loginToken) {
            this.removeLoginInfo();
            return throwError(() => error);
          }

          return this.http.get(`${this.baseUrl}v1/auth/refresh`, {
            headers: new HttpHeaders({
              Authorization: `${loginToken}`
            })
          }).pipe(
            switchMap((res: any) => {
              if (res.status === false|| !res?.access_token ) {
                this.removeLoginInfo();
                return throwError(() => new Error('Token generation failed'));
              }

              const newToken = res?.access_token || '';
              localStorage.setItem('userToken', newToken);
              const retryReq = request.clone({
                setHeaders: { Authorization: newToken }
              });
              return next.handle(retryReq);
            }),
            catchError((tokenError) => {
             this.removeLoginInfo();
              return throwError(() => tokenError);
            })
          );
        }
        return throwError(() => error);
      })
    );
  }

  removeLoginInfo() {
    localStorage.removeItem('userToken');
    localStorage.removeItem('logdinUser');
    localStorage.removeItem('Role');
    localStorage.removeItem('Name');
    this.router.navigate(['auth/login']);
  }
}

